import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { equals, last } from 'ramda';
import { Text } from '@daedalus/atlas/Text';
import { getCancellationDeadline, getHasFreeCancellation } from '@daedalus/core/src/offer/business/cancellationPenalties';
const _exp = /*#__PURE__*/() => Text;
const RoomLabelsText = /*#__PURE__*/styled(_exp())({
  name: "RoomLabelsText",
  class: "razu2wu",
  propsAsIs: true
});
const RoomLabelsItem = /*#__PURE__*/styled('span')({
  name: "RoomLabelsItem",
  class: "r1pydkhg",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => RoomLabelsText;
const Dot = /*#__PURE__*/styled(_exp6())({
  name: "Dot",
  class: "dewwzjg",
  propsAsIs: true
});
interface Props {
  /** Offer state */
  offer: SearchOffer;
  shouldShowFreeCancellation?: boolean;
}
const roomLabels = defineMessages({
  freeCancellation: {
    id: 'hotelOffer.freeCancellation',
    defaultMessage: 'FREE cancellation'
  },
  yourChoice: {
    id: 'yourChoice',
    defaultMessage: 'Your Choice'
  }
});
export const YourChoiceAndFreeCancelationLabels = ({
  offer,
  shouldShowFreeCancellation = false
}: Props) => {
  const {
    formatMessage,
    formatDate
  } = useIntl();
  const hasFreeCancellation = getHasFreeCancellation(offer?.cancellationPenalties);
  const translateFreeCancelation = () => {
    if (hasFreeCancellation) {
      const freeCancellationMessage = formatMessage(roomLabels.freeCancellation);
      const freeCancellationDeadline = getCancellationDeadline(offer.cancellationPenalties);
      const freeCancellationDeadlineMessage = formatMessage({
        id: 'beforeDeadline',
        defaultMessage: 'before {date}'
      }, {
        date: formatDate(freeCancellationDeadline, {
          day: '2-digit',
          month: 'short',
          timeZone: 'UTC'
        })
      });
      return `${freeCancellationMessage} ${freeCancellationDeadlineMessage}`;
    }
    return '';
  };
  const translatedLabels = shouldShowFreeCancellation ? [{
    id: roomLabels.yourChoice.id,
    label: formatMessage(roomLabels.yourChoice)
  }, {
    id: roomLabels.freeCancellation.id,
    label: translateFreeCancelation()
  }] : [{
    id: roomLabels.yourChoice.id,
    label: formatMessage(roomLabels.yourChoice)
  }];
  return <RoomLabelsText dataId="RoomLabels" className="container-rooms-label">
      {translatedLabels.map(({
      label,
      id
    }) => {
      return <RoomLabelsItem className={cx(id === roomLabels.yourChoice.id && '__isYourChoice')} key={id}>
            {label}
            {!equals(last(translatedLabels).label, label) && <Dot as="span">·</Dot>}
          </RoomLabelsItem>;
    })}
    </RoomLabelsText>;
};

require("./YourChoiceAndFreeCancelationLabels.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./YourChoiceAndFreeCancelationLabels.tsx");